import React, { useCallback } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import strings from 'strings';

import { RESUME_SORT_OPTIONS } from '../../ResumeSearch.constants';

const sortCopies = strings.resumeSearch.sort;

export const SortSelect = ({ value, onChange, disabled = false }) => {
  const handleChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <FormControl size="small" style={{ minWidth: 160 }} variant="outlined">
      <InputLabel>{sortCopies.label}</InputLabel>
      <Select label={sortCopies.label} value={value} onChange={handleChange} disabled={disabled}>
        {RESUME_SORT_OPTIONS.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {sortCopies.options[option.id]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
